import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../utils/reduxHelper.js";

export const BrandsPageReduxAPI = createApi({
  reducerPath: "BrandsPageReduxAPI",
  baseQuery: baseQueryWithArgs,

  endpoints: (builder) => ({
    //GET Queries
    fetchOnboardingBrands: builder.query({
      query: () => getQueryStringWithCreator(`c/fetchOnboardingBrands`),
    }),
    updateCreatorOnboardingBrands: builder.mutation({
      query: (body) => ({
        url: `/c/updateCreatorOnboardingBrands`,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
    fetchAmazonEarnings: builder.query({
      query: ({ startDate, endDate }) =>
        getQueryStringWithCreator(
          `/c/getAmazonEarningsData?startDate=${startDate}&endDate=${endDate}`
        ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyFetchOnboardingBrandsQuery,
  useLazyFetchAmazonEarningsQuery,
  useUpdateCreatorOnboardingBrandsMutation,
} = BrandsPageReduxAPI;
